"use client";

import React from 'react';
import styles from './_gc-step-pill.module.scss';
import Button from '@/components/button';

/**
 * @description GC Calculator — Step Pill
 * Displays a wizard step as either a completed (eggplant) or disabled (muted)
 * pill. Completed pills expose a "Review" CTA to navigate back to that step.
 *
 * @param {Object}   step         — step definition from GC_CALC_STEP_DEFINITIONS
 * @param {boolean}  isCompleted  — true = eggplant pill; false = disabled muted pill
 * @param {string}   [sublabel]   — optional small label above step name (e.g. "Start here")
 * @param {Function} [onReview]   — callback when Review is clicked (completed only)
 */
function GcStepPill({ step, isCompleted, isEnabled, sublabel, onReview, onStart, actionsDisabled }) {
  const isClickable = (isCompleted || isEnabled) && !actionsDisabled;
  const handleClick = isCompleted ? onReview : onStart;
  const pillClass = isCompleted ? styles.completed : isEnabled ? styles.enabled : styles.disabled;

  return (
    <div className={`${styles.pill} ${pillClass}`}>
      <div className={styles.pill_info}>
        {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
        <span className={styles.label}>{step.label}</span>
      </div>
      <Button
        type="button"
        variant="solid"
        customClass={styles.review_btn}
        onClick={isClickable ? handleClick : undefined}
        disabled={!isClickable}
        data-gtm-event-category="gc-calculator"
        data-gtm-event-action="Click"
        data-gtm-event-label={`Review: ${step.label}`}
      >
        Review
      </Button>
    </div>
  );
}

export default GcStepPill;
